import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
  Table,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableBody,
  TableRowColumn
} from 'material-ui/Table';
// css
import Dialog from 'material-ui/Dialog';
import Select from 'react-select';
import FlatButton from 'material-ui/FlatButton';
import ReassignClientDialog from './ReassignClientDialog';
import SuspendUser from './SuspendUser';
import './user-status.css';
import {buttonBlueColor} from "../../utils/utility";
import qs from 'qs';
import moment from 'moment';

import {isEmpty} from 'lodash'

const styles = {
  tableHeaderStyle: {
    border: 'none',
    background: '#E4E4E4'
  },
  arrowStyle: {
    position: 'absolute',
    top: '0'
  },
  tableHeaderColumn: {
    height: '30px',
    color: 'black',
    cursor: 'pointer',
    fontWeight: 'bolder',
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    paddingLeft: '10px'
  },
  tableHeaderSortedColumn: {
    height: '30px',
    color: 'black',
    cursor: 'pointer',
    fontWeight: 'bolder',
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    backgroundColor: "#CECECE",
    paddingLeft: '10px',
    backgroundClip: 'padding-box'
  },
  tableRowColumn: {
    position: 'relative',
    paddingLeft: '10px',
    height:'30px'
  },
  settingStyle: {
    position: 'absolute',
    right: '6em',
    top: '0.9em',
    cursor: 'pointer'
  }
}

class UserStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableList: [],
      open: false,
      rolesValue: '',
      reassignClientDialogOpen: false,
      suspendUserOpen: false,
      reassignLabel: '',
      showTips: false
    }
    this.throttle = true;
    this.throttle_assign = true;
  }
  componentDidMount () {
    let cid = undefined
    if (!isEmpty(this.props.location.search)){
      cid = this.props.location.search.replace("?cid=", '')
    }
    this.setState({cid: cid})
    const params = {
      pageNumber: +this.props.match.params.pageNumber,
      pageSize: 10,
      sortColumn: this.props.match.params.sortColumn, //support name , role, email, status field
      order: this.props.match.params.order // asc or desc
    }

    // administrator or team member
    if (this.props.roleId > 50){
      this.props.getClientRoles()
      if (
        /^\/clients\/edit\/Client-Team-Members/.test(this.props.location.pathname) &&
        /^(administrator|team member)/gi.test(this.props.roleName)
      ) {
        let clientId= qs.parse(this.props.location.search.split('?')[1]).cid;
        this.props.getBusinessUnitTeamMembers(clientId, this.props.match.params.id)
      } else {
        this.props.getTableList(params, cid);
      }
    }
    else if (this.props.roleId > 0){
      if (isEmpty(cid)){
        this.props.getRoles()
        this.props.getTableList(params);
      } else {
        this.props.getClientRoles()
        if (/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname)) {
          let businessId = qs.parse(this.props.location.search.split('?')[1]).id;
          this.props.getBusinessUnitTeamMembers(this.props.match.params.id, businessId)
        } else {
          this.props.getTableList(params, cid)
        }
      }
    }
    let roleName = JSON.parse(localStorage.getItem('session')).roleName;
    if (/system administrator/gi.test(roleName)) {
      this.props.getAccountManage();
    }
  }
  componentWillReceiveProps (nextProps) {
    // when data role is changed rerender UI
    if (typeof roleName === 'string' || /^system administrator/gi.test(nextProps.roleName)) {
      this.setState({
        reassignLabel: 'REASSIGN CLIENTS'
      })
    } else if (typeof roleName === 'string' || /^administrator/gi.test(nextProps.roleName)) {
      this.setState({
        reassignLabel: 'REASSIGN BUSINESS UNITS'
      })
    }
    if (Array.isArray(nextProps.tableList.data)) {
      let tableList;
      tableList = nextProps.tableList.data.filter((item) => item.id === +nextProps.match.params.id);
      this.setState({
        tableList,
        rolesValue: tableList.length > 0 && tableList[0].role.id
      });
      // get client list for systemn administrator
      if (this.throttle_assign && tableList.length > 0) {
        nextProps.getClientAssignments(tableList[0].id);
        this.throttle_assign = false;
      }
    }

    // filter data for router: /clients/edit/Business-Units/detail/Business Unit Team Members/
    if (Array.isArray(nextProps.client_team_members)) {
      let tableList;
      if (
        /^\/clients\/edit\/Client-Team-Members/.test(nextProps.location.pathname) &&
        /^(administrator|team member)/gi.test(nextProps.roleName)
      ) {
        tableList = nextProps.client_team_members.filter((item) => item.id === +this.props.match.params.id);
      } else {
        tableList = nextProps.client_team_members.filter((item) => item.id === +qs.parse(nextProps.location.search.split('?')[1]).cid);
      }
      this.setState({
        tableList,
        rolesValue: tableList.length > 0 && tableList[0].role.id
      })
    }
    if (this.throttle && typeof nextProps.selected_client === 'number') {
      nextProps.getAccountManage(nextProps.selected_client) // for client
      const params = {
        pageNumber: +nextProps.match.params.pageNumber,
        pageSize: 10,
        sortColumn: nextProps.match.params.sortColumn, //support name , role, email, status field
        order: nextProps.match.params.order // asc or desc
      }
      if (nextProps.roleId > 50){
        nextProps.getClientRoles()
        // for administrator | team member in business unit team member
        if (
          /^\/clients\/edit\/Client-Team-Members/.test(nextProps.location.pathname) &&
          /^(administrator|team member)/gi.test(nextProps.roleName)
        ) {
          let clientId= qs.parse(nextProps.location.search.split('?')[1]).cid;
          nextProps.getBusinessUnitTeamMembers(clientId, clientId)
        } else {
          nextProps.getTableList(params, nextProps.selected_client);
        }
      }
      else if (nextProps.roleId > 0){
        if (this.props.location.search === ''){
          nextProps.getTableList(params);
          nextProps.getRoles()
        }

        else{
          nextProps.getClientRoles()
          // cid some time can be undefined ,use this.props.location.search

          if (/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname)) {
            let businessId = qs.parse(this.props.location.search.split('?')[1]).id;
            this.props.getBusinessUnitTeamMembers(this.props.match.params.id, businessId)
          } else {
            nextProps.getTableList(params, this.props.location.search.split('=')[1])
          }
        }
      }
      this.throttle = false;
    }

    // nextProps.getClientAssignments(tableList[0].id);
  }
  getClientAssignmentsAgain  () {
    this.props.getClientAssignments(this.state.tableList[0].id);
  }
  handleUpdateRole () {
    this.setState({
      open: true
    })
  }
  handleItemsChange (valObj) {
    this.setState({
      rolesValue: valObj.value
    })
  }
  closeDialog () {
    if (this.props.ifUpdateRoleSuccess) {
      this.props.rollBackUpdateStatus();
      const params = {
        pageNumber: 1,
        pageSize: 10,
        sortColumn: 'name', //support name , role, email, status field
        order: 'desc' // asc or desc
      }
      if (this.props.roleId > 50){
        this.props.getTableList(params, this.props.selected_client);
      }
      else if (this.props.roleId > 0){
        if (isEmpty(this.state.cid))
          this.props.getTableList(params);
        else
          this.props.getTableList(params, this.state.cid)
      }
    }
    this.setState({
      open: false
    })

  }
  handleSave () {
    if (isEmpty(this.state.cid))
      this.props.updateRole(this.props.match.params.id, this.state.rolesValue)
    else
      this.props.updateRole(this.props.match.params.id, this.state.rolesValue, true)
  }

  handleRessignClients () {
    if ((this.state.tableList[0].role.name !== 'Account Manager') && (this.props.roleId === 1)) {
      this.setState({
        showTips: true
      });

      return ;
    }
    this.setState({
      reassignClientDialogOpen: true
    }, () => {
      let ThEleCollection = document.querySelectorAll('.reassign-table th');
      let ThEleCollection_td = document.querySelectorAll('.reassign-table td');
      for (let i of ThEleCollection) {
        i.style.height = '32px';
      }
      for (let i of ThEleCollection_td) {
        i.style.height = '32px';
      }
    })
  }
  closeReassignClientDialog () {
    this.setState({
      reassignClientDialogOpen: false
    })
  }
  handleSuspendUser () {
    this.setState({
      suspendUserOpen: true
    })
  }
  closeSuspendUser () {
    this.setState({
      suspendUserOpen: false
    })
  }
  getNavBar(){
    if ((!this.props.ifForInternalPage) && (isEmpty(this.state.cid))) {
      return (
        <ul className="clearfix">
        <li>
          <a href="/employees">Team</a>
        </li>
        <li>></li>
        <li>
          User Status
        </li>
      </ul>
      )
    }
/*
    if (!isEmpty(this.state.cid)) {
      return (
        {
        <ul className="clearfix">
        <li>
          <a href="/Clients">Client</a>
        </li>
        <li>></li>
        <li>
          <a href={`/clients/edit/Client-Team-Members/${this.state.cid}`}>Client Team Members</a>
        </li>
        <li>></li>
        <li>
          User Status
        </li>
      </ul>
      
      )
    }*/

  }
  handleCloseTips () {
    this.setState({
      showTips: false
    })
  }
  showRoleUpdate () {
    if (/^\/employees\/user-status/.test(this.props.location.pathname)) {
      return (<button className="blue" onClick={() => this.handleUpdateRole()}>UPDATE ROLE</button>);
    }
    if (/^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) {
      return (<button className="blue" onClick={() => this.handleUpdateRole()}>UPDATE ROLE</button>);
    }
  }
  render () {
    const muiTheme = getMuiTheme({
      menuItem: {
        hoverColor: buttonBlueColor()
      },
      checkbox: {
        checkedColor: buttonBlueColor()
      },
      tableRow: {
        selectedColor: 'white'
      }
    });
    const tableList = this.state.tableList.length > 0 && this.state.tableList[0]
    const roles = isEmpty(this.state.cid) ? this.props.roles : this.props.clientRoles;
    const tableHeaderArr = /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) ?
      [{ name: 'Name', value: 'name' }, { name: 'Role', value: 'role' },
        { name: 'Email', value: 'email' }, { name: 'Status', value: 'status' },
        { name: 'Last Logged on', value: 'lastLoggedonDatetime'}] :
      [
        {name:'Name', value: 'name'},
        {name: 'Role', value: 'role'},
        {name: 'Email', value: 'email'},
        {name: 'Status', value: 'status'}
      ]
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="employees-user-status employees">
          <Dialog
            modal={true}
            contentStyle={{ width: '40%' }}
            open={this.state.open}
            bodyStyle={{overflowY: 'inherit', padding: '20px'}}
          >

            <div className="clearfix" style={{position: 'relative'}}>
              <h2 style={{fontSize: '16px', fontWeight: 'bolder', color: 'black', marginTop: '0', marginBottom: '12px'}}>
                UPDATE ROLE
              </h2>
              <div className="clearfix" style={{height: '32px'}}>
                {
                  !this.props.ifUpdateRoleSuccess && (
                    <span style={{fontSize: '14px', color: 'black', fontWeight: 'bolder'}}>Role</span>
                  )
                }
                {
                  !this.props.ifUpdateRoleSuccess && (
                    <Select
                      className="iv-role-selector"
                      value={this.state.rolesValue}
                      clearable={false}
                      options={roles.filter((item) => item.value !== 53)}
                      onChange={this.handleItemsChange.bind(this)}
                    />
                  )
                }
              </div>

              {
                this.props.ifUpdateRoleSuccess && (
                  <p style={{textAlign: 'center', color: 'black'}}>Update successfully</p>
                )
              }

              <div className="form-btns clearfix" style={{marginTop:'19px'}}>
                {
                  !this.props.ifUpdateRoleSuccess && (
                    <FlatButton
                      label="SAVE"
                      labelStyle={{fontSize: '13px', padding: 0}}
                      style={{minWidth: 'auto', width: '54px', fontSize: '14px', color: 'white ', float: 'right', height: '30px', lineHeight: '30px'}}
                      backgroundColor={buttonBlueColor()}
                      hoverColor={buttonBlueColor()}
                      onClick={() => this.handleSave()}
                      disabled={this.state.ifInviteButtonDisable}
                    />
                  )
                }
                <a className="btn btn-link pull-right " id="userStatusA" style={{ marginLeft: '-1.3em', border: '1px solid black', fontWeight: 'bolder', padding: '8px 9px', borderRadius: '0', marginRight: '0.8em', height: '30px', lineHeight: '1.23'}}
                   onClick={(e) =>  this.closeDialog() } >{!this.props.ifUpdateRoleSuccess ? 'Cancel' : 'Close'}</a>
              </div>
            </div>
          </Dialog>
          {/*ifForInternalPage when this value is true will hidden the routeBread.*/}
          {/*this value will be pass from /edit/Client-Team-Members/detail */}
          { this.getNavBar() }
          <div className="wrapper" style={{ paddingLeft: '2%', paddingRight: '2%', marginTop: 0}}>
            <h5>
              {
                /^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) ?
                (
                /^(administrator|team member)/gi.test(this.props.roleName) ?
                'BUSINESS UNIT TEAM MEMBER STATUS' :
                'TEAM MEMBER STATUS'
                ) :
                'USER STATUS'
              }
            </h5>
            <div>
              <Table
              >
                <TableHeader
                  displaySelectAll={false}
                  style={styles.tableHeaderStyle}
                  adjustForCheckbox={false}
                >
                  <TableRow
                    displayBorder={false}
                    style={{ height: '30px' }}
                  >
                    {
                      tableHeaderArr.map((item, index) => (
                      <TableHeaderColumn
                        style={{...styles.tableHeaderColumn, textAlign: 'left'}}
                        key={index}
                      >
                        {item.name}
                      </TableHeaderColumn>
                    ))}
                    {/*<TableHeaderColumn style={{height: '35px'}}></TableHeaderColumn>*/}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                >
                  {
                    this.state.tableList.length > 0 && (
                      <TableRow
                        selectable={false}
                        key={tableList.id}
                        style={{borderBottom: '1px solid black', height:'30px'}}
                      >
                        <TableRowColumn style={{...styles.tableRowColumn, cursor: 'pointer'}}>
                          <span>{`${tableList.firstName} ${tableList.lastName}`}</span>
                        </TableRowColumn>
                        <TableRowColumn style={{...styles.tableRowColumn}}>
                          {tableList.role !== undefined && tableList.role.name}
                        </TableRowColumn>
                        <TableRowColumn style={styles.tableRowColumn}>
                          {tableList.email}
                        </TableRowColumn>
                        <TableRowColumn style={{...styles.tableRowColumn, textAlign: 'left'}}>
                          {tableList.status}
                        </TableRowColumn>
                        {
                          /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) && (
                            <TableRowColumn style={{...styles.tableRowColumn, textAlign: 'left'}}>
                              {tableList.lastLoggedonDatetime ? moment.unix(tableList.lastLoggedonDatetime/1000).format('M/D/YY') : ''}
                            </TableRowColumn>
                          )
                        }
                      </TableRow>
                    )
                  }

                </TableBody>
              </Table>
            </div>

            <div className="btns">
              {this.showRoleUpdate()}
              {/*{*/}
                {/*!/^(\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members|\/clients\/edit\/Client-Team-Members\/user-status)/g.test(this.props.location.pathname) && (*/}
                  {/*<button className="blue" onClick={() => this.handleUpdateRole()}>UPDATE ROLE</button>*/}
                {/*)*/}
              {/*}*/}
              {/*{*/}
                {/*!(*/}
                  {/*/^\/clients\/edit\/Client-Team-Members\/user-status/.test(this.props.location.pathname) &&*/}
                  {/*/^(administrator|team member)/.test(this.props.roleName)*/}
                {/*) && (*/}
                  {/*<button className="blue" onClick={() => this.handleUpdateRole()}>UPDATE ROLE</button>*/}
                {/*)*/}
              {/*}*/}
              {isEmpty(this.state.cid) &&  <button className="blue" onClick={() => this.handleRessignClients()}>
                {this.state.reassignLabel}
              </button>}
              {
                (tableList.status === 'Suspended') && (
                  <button className="red" onClick={() => this.handleSuspendUser()}>
                    {/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) ?
                      'REACTIVATE BUSINESS UNIT TEAM MEMBER' :
                      /^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) ?
                        (
                          /^(administrator|team member)/gi.test(this.props.roleName) ?
                          'REACTIVATE BUSINESS UNIT TEAM MEMBER' :
                          'REACTIVATE TEAM MEMBER'
                        ) :
                        'REACTIVATE USER'
                    }
                  </button>
                )
              }
              {
                (tableList.status === 'Active') && (
                  <button className="red" onClick={() => this.handleSuspendUser()}>
                    {/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname) ?
                      'SUSPEND BUSINESS UNIT TEAM MEMBER' :
                      /^\/clients\/edit\/Client-Team-Members\/user-status/g.test(this.props.location.pathname) ?
                        (
                          /^(administrator|team member)/gi.test(this.props.roleName) ?
                            'SUSPEND BUSINESS UNIT TEAM MEMBER' :
                            'SUSPEND TEAM MEMBER'
                        ) :
                      'SUSPEND USER'
                    }
                  </button>
                )
              }
            </div>
            {/*when not account manager*/}
            <Dialog
              modal={false}
              open={this.state.showTips}
              onRequestClose={this.handleClose}
            >
              <p style={{color: 'black', textAlign: 'center'}}>
                This user is not an account manager
              </p>
              <div className="btns" style={{textAlign: 'center', marginTop: '1em'}}>
                <FlatButton
                  label="CLOSE"
                  className="btn-aa-info"
                  backgroundColor={buttonBlueColor()}
                  labelStyle={{color: 'white'}}
                  onClick={() => this.handleCloseTips()}
                  hoverColor={buttonBlueColor()}
                />
              </div>
            </Dialog>
          </div>
          {/*ressign client dialog*/}
          <ReassignClientDialog
            open={this.state.reassignClientDialogOpen}
            closeDialog={() => this.closeReassignClientDialog()}
            account_manager={this.props.account_manager}
            suspendUserId={tableList.id}
            suspended={tableList.status === 'Suspended'}
            client_assignments={this.props.client_assignments}
            ifReassignSuccess={this.props.ifReassignSuccess}
            reassingAccountManager={this.props.reassingAccountManager}
            originAccountManagerUserId={this.props.match.params.id}
            rollBackReassign={this.props.rollBackReassign}
            getClientAssignmentsAgain={() => this.getClientAssignmentsAgain()}
            roleName={this.props.roleName}
            client_assignments_error={this.props.client_assignments_error}
          />
          <SuspendUser
            isClientUser={/^\/employees\/user-status/g.test(this.props.location.pathname)}
            open={this.state.suspendUserOpen}
            roleName={this.props.roleName}
            location={this.props.location}
            businessUnitTeamMemberPage={/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(this.props.location.pathname)}
            userId={this.props.userId}
            closeSuspendUser={() => this.closeSuspendUser()}
            suspendUser={this.props.suspendUser}
            suspendUserId={tableList.id}
            suspended={tableList.status === 'Suspended'}
            suspend_error={this.props.suspend_error}
            clearSuspendError={this.props.clearSuspendError}
          />
        </div>
      </MuiThemeProvider>
    )
  }
}

export default UserStatus;


// WEBPACK FOOTER //
// ./src/components/Employees/UserStatus.jsx